module.exports = __webpack_public_path__ + "2f7602ed850a14b59871b52241a09d82.svg";